import React, { useState, useEffect, useContext } from "react"
import Context from "../utils/Context"
import ShowMessage from "./ShowMessage"
import DraggableTagList from "./elements/DraggableTagList"

export default function ModalTask() {

  const context = useContext(Context)
  const defaultTask = { robot: context.selectedRobot.name, mapIndex: context.mapIndex }
  const [selectedTask, setSelectedTask] = useState(defaultTask)
  const [selectedAction, setSelectedAction] = useState()
  const [inputValue, setInputValue] = useState()
  const [saveState, setSaveState] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [removeSelected, setRemoveSelected] = useState(false)
  const [min, setMin] = useState(0)
  const [max, setMax] = useState(0)
  const [step, setStep] = useState(0)
  const [cacheAction, setCacheAction] = useState([])
  const [currentMap, setCurrentMap] = useState()

  useEffect(() => {
    setCurrentMap(context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id))
  }, [])

  // saveState
  useEffect(() => {
    setSaveState(
      selectedTask &&
        selectedTask.name &&
        selectedTask.actions &&
        selectedTask.actions.length > -1
        ? true
        : false
    )
  }, [selectedTask])

  useEffect(() => {

    validadeRuleValues()
  },
    [selectedAction])

  let modalMessage
  switch (selectedAction?.name) {
    case "pause": modalMessage = "Minimal value is 0.1"; break
    case "desinfect-uv": modalMessage = "Minimal value is 0.1"; break
    case "desinfect-all": modalMessage = "Minimal value is 0.1"; break
    case "rotate": modalMessage = "Insert an integer angle in degrees"; break
    default:
  }

  const comboSelect = (name) => {

    var list = context.availableSubActions.find((e) => e.name === name).values;

    return list
  }

  const getCache = (action) => {

    const found = cacheAction.find(element => element.action === action);

    return found ? found.value : null

  }

  const validAction = (action, value) => {

    var validate = cacheAction

    const indx = validate.findIndex(v => v.action === action.name)
    if (~indx) {
      validate.splice(indx, 1)
      validate.push({ action: action.name, value: value })
      setCacheAction(validate)
    } else {
      validate.push({ action: action.name, value: value })
      setCacheAction(validate)
    }

  }


  // select task
  const selectTask = (event) => {
    setRemoveSelected(false)
    const task =
      event.target.value === ""
        ? defaultTask
        : context.availableTasks.find((task) => task.name === event.target.value)
    setSelectedTask(task)
    setIsEditing(true)

  }

  // handle task selection
  const handleChange = async (target) => {
    setSelectedTask((selected) => ({ ...selected, [target.id]: target.value }))

  }

  // insert or update item to array helper
  const pushToArray = (obj, arr) => {
    const index = arr.findIndex((e) => e.name === obj.name)
    if (index === -1) {
      arr.push(obj)
    } else {
      arr[index] = obj
    }
    return arr
  }

  // save task
  const save = async () => {
    let msg = "Please fill task name and add at least 1 action"
    let typeMsg = "error"
    let task

    console.log(context.user)
    if (currentMap) task = { ...selectedTask, mapId: currentMap._id, owner: currentMap.owner, areaId: currentMap.areaId, robot: context.selectedRobot.name }
    else task = { ...selectedTask, robot: context.selectedRobot.name }

    if (saveState) {
      const newTasks = pushToArray(task, [...context.availableTasks])
      context.actions.setAvailableTasks(newTasks)
      msg = "Task saved"
      typeMsg = "success"
    }
    context.actions.setMessage({ message: msg, type: typeMsg })
  }

  // select action
  const selectAction = (event) => {

    setInputValue(null)

    setSelectedAction(null)
    if (!selectedTask) setSelectedTask(defaultTask)

    const action = context.availableActions.find(
      (action) => action.name === event.target.value
    )

    //console.log('selecting action', action, event.target.value)

    setInputValue(getCache(action.name))
    setSelectedAction(action)
  }

  const validateRules = () => {

    if ((selectedAction && selectedAction.needs_value && inputValue) || (selectedAction && !selectedAction.needs_value)) {

      if (selectedAction.name === "pause") {
        if (inputValue > 0) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (selectedAction.name === "desinfect-uv" || selectedAction.name === "desinfect-all") {
        if (inputValue > 0) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (selectedAction.name === "rotate") {
        if (Number.isInteger(Number(inputValue))) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (inputValue === "Select destination..." || inputValue === "Select event...") {
        context.actions.setMessage({ message: "Invalid action.", type: "error" })
        return false
      }
      else {
        return true
      }

    } else {
      context.actions.setMessage({ message: "Invalid action.", type: "error" })
      return false
    }
  }

  const validadeRuleValues = () => {

    switch (selectedAction?.name) {
      case "pause": setMin(1); setMax(10000); setStep(1); break
      case "desinfect-uv": setMin(0.1); setMax(1.6); setStep(0.1); break
      case "desinfect-all": setMin(0.1); setMax(1.6); setStep(0.1); break
      case "rotate": setMin(1); setMax(360); setStep(1); break
      case "fork": setMin(0); setMax(3); setStep(1); break
      default:
    }

  }

  // add action
  const addAction = () => {

    if (!validateRules()) {
      return false
    }

    let newAction = { ...selectedAction }

    if (inputValue) newAction = { ...newAction, value: inputValue }
    if (newAction.valueType) delete newAction.valueType

    let actions = selectedTask.actions
      ? selectedTask.actions.map((item) => ({ ...item }))
      : []

    actions = [...actions, newAction]

    setSelectedTask({ ...selectedTask, actions: actions })

  }

  // remove action
  const removeAction = (indexAction) => {
    const actions = [].concat(selectedTask.actions)
    actions.splice(indexAction, 1)
    setSelectedTask({ ...selectedTask, actions: actions })
  }

  // delete task
  const remove = () => {
    let newTasks = [...context.availableTasks]
    newTasks.splice(context.availableTasks.indexOf(selectedTask), 1)
    context.actions.setAvailableTasks(newTasks)
    clear()
    context.actions.setMessage({ message: "Task deleted.", type: "success" })
    setRemoveSelected(true)
  }

  // clear for new task input
  const clear = () => {
    setSelectedTask(defaultTask)
    setIsEditing(true)
  }

  // handle select values
  const handleSelectValue = (event) => {

    validAction(selectedAction, event.target.value)
    setInputValue(event.target.value)

  }


  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>

        <header className="modal-card-head">
          <p className="modal-card-title">Tasks</p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => context.actions.setModalState({ ...context.modalState, tasks: false })}
          ></button>
        </header>

        <section className="modal-card-body">

          <div className="field mb-5">
            <label className="label">Tasks</label>
            <div className="control">
              <button className="button is-success" onClick={clear} style={{ marginRight: "1rem" }}>
                Create new Task
              </button>
              <div className="select">
                <select name="task" onChange={selectTask}
                  defaultValue={"Edit task..."}>
                  {removeSelected ? (
                    <option selected disabled>Edit task...</option>
                  ) :
                    <option disabled>Edit task...</option>
                  }
                  {context.availableTasks?.map((item, i) =>
                    item.robot === context.selectedRobot.name && (
                      <option key={i}>
                        {item.name}
                      </option>
                    ))}
                  {//currentMap && context.availableTasks?.map((item, i) =>                    item.robot === context.selectedRobot.name && item.mapId === currentMap._id && (                      <option key={i}>                        {item.name}                      </option>                    ))
                  }
                </select>
              </div>
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Name</label>
            <div className="control">
              <input
                id="name"
                type="text"
                className="input"
                placeholder={"New task name..."}
                value={selectedTask && selectedTask.name ? selectedTask.name : ""}
                onChange={(event) => handleChange(event.target)}
              />
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Action</label>

            <div className="select mr-3">
              <select name="action" onChange={selectAction} defaultValue={"Add action..."} selected={selectedAction && selectedAction.name ? selectedAction.name : ""}>
                <option disabled>Add action...</option>
                {context.availableActions && context.availableActions.map((item, i) => (
                  <option key={i} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            {selectedAction && selectedAction.valueType === "point" ?
              <div className="select">
                <select name="destination" onChange={handleSelectValue} defaultValue={"Select destination..."} value={inputValue ? inputValue : "Select destination..."}>
                  <option disabled>Select destination...</option>
                  {context.maps && context.konvaPoints.map((item, i) => {
                    if (item.fill === 'blue') {
                      return <option key={i} value={item.name}>
                        {item.name}
                      </option>
                    }
                  })}
                </select>
              </div>
              : selectedAction && selectedAction.valueType === "value" ?
                <input
                  type="number"
                  className="input"
                  placeholder="Value"
                  value={inputValue ? inputValue : ""}
                  onChange={(event) => setInputValue(event.target.value)}
                  style={{ width: "10rem" }}
                  min={min}
                  max={max}
                  step={step}
                />
                : selectedAction && selectedAction.valueType === "onOff" ?
                  <div className="select">
                    <select name="event" onChange={handleSelectValue} defaultValue={"Select event..."} value={inputValue ? inputValue : "Select event..."}>
                      <option disabled>Select event...</option>
                      {comboSelect(selectedAction.valueType).map((item, i) => (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                  : selectedAction && selectedAction.valueType === "startEnd" ?
                    <div className="select">
                      <select name="event" onChange={handleSelectValue} defaultValue={"Select event..."} value={inputValue ? inputValue : "Select event..."}>
                        <option disabled>Select event...</option>
                        {comboSelect(selectedAction.valueType).map((item, i) => (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    : selectedAction && selectedAction.valueType === "docking" ?
                      <div className="select">
                        <select name="event" onChange={handleSelectValue} defaultValue={"Select target..."} value={inputValue ? inputValue : "Select target..."}>
                          <option disabled>Select target...</option>
                          {comboSelect(selectedAction.valueType).map((item, i) => (
                            <option key={i} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                      : selectedAction && selectedAction.valueType === "upDown" ?
                        <div className="select">
                          <select name="event" onChange={handleSelectValue} defaultValue={"Select event..."} value={inputValue ? inputValue : "Select event..."}>
                            <option disabled>Select event...</option>
                            {comboSelect(selectedAction.valueType).map((item, i) => (
                              <option key={i} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                        : selectedAction && selectedAction.valueType === "mapList" ?
                          <div className="select">

                            <select className="select mb-2 mr-2" name="maps" onChange={handleSelectValue} defaultValue={"Select Map..."} style={{ minHeight: "2.5rem" }} value={inputValue ? inputValue : "Select Map..."} >
                              <option disabled>Select Map...</option>
                              {context.maps.map((m, i) =>
                                m.robot === context.selectedRobot?.name &&
                                <option key={i} value={m?.name}>
                                  {m?.name?.length >= 15 ? m?.name?.slice(0, 12) + "..." : m?.name?.slice(0, 14)}
                                </option>
                              )}
                            </select>

                          </div>
                          : null}

            <button className="button is-light" onClick={addAction}>
              Add
            </button>
          </div>

          {selectedTask && selectedTask.actions &&
            <DraggableTagList
              itemList={selectedTask.actions}
              removeAction={removeAction}
              saveOrder={(updatedActions) =>
                setSelectedTask({ ...selectedTask, actions: updatedActions })
              }
              renderTagContent={(action) =>
                action.value ? `${action.name} ${action.value}` : action.name
              }
            />
          }

          <div className="field mb-5">
            <div className="control">
              <button className="button is-success" onClick={save} style={{ marginRight: "1rem" }}>
                Save changes
              </button>
              {isEditing ?
                <button className="button is-danger" onClick={remove}>
                  Delete Task
                </button>
                : null
              }
            </div>
          </div>

          <ShowMessage />

        </section>
      </div>
    </div>
  )
}

